module.exports = __webpack_public_path__ + "img/share-icon.407afdbe.svg";